import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { FinancialItemLineMergeData } from './financial.item.line.merge.data';

@MergeSchema({
    entity: ActivityEntityName.SaleOrderItems,
    name: 'SaleOrderItemsMergeDataSchema',
})

export class SaleOrderItemsMergeData {
    @MergeField({
        arraySchemaName: 'FinancialItemLineMergeDataSchema'
    })
    items: FinancialItemLineMergeData[] = [];
}

export const SaleOrderItemsMergeDataSchema = getSchema(SaleOrderItemsMergeData)